import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/primeng';
import { DownloadModalComponent } from './download-modal.component';

@NgModule({
  imports: [
    CommonModule, DialogModule
  ],
  declarations: [DownloadModalComponent],

  exports: [DownloadModalComponent]
})
export class DownloadModalModule { }



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/user/student/student-resume/download-modal/download-modal.module.ts